import { createSlice } from "@reduxjs/toolkit";


export type ConfigStateType={
    direction?:"ltr"|"rtl",
}


const setupInitialState =():ConfigStateType=>({
    direction: "ltr",
})




export const configSlice= createSlice({
    name:"config",
    initialState:setupInitialState(),
    reducers:{
        setDirection:(state:ConfigStateType,action)=>{
            state.direction=action.payload;
        }
    }

})


export const {setDirection}  = configSlice.actions;
export const configReducer = configSlice.reducer;
